import React, { FC } from 'react';
import { TextButton as TPATextButton, TextButtonProps } from 'wix-ui-tpa';
import { st, classes } from './TextButton.st.css';

export const TextButton: FC<TextButtonProps> = ({ className, ...rest }) => {
  return <TPATextButton className={st(classes.root, className)} {...rest} />;
};
